export const teamDirectory = {
  contacts: [
    { name: 'Head of Product', role: 'VP Product', email: 'head-of-product@company.com', slack: '@head-product' },
    { name: 'Scrum Master', role: 'Agile Coach', email: 'scrum-master@company.com', slack: '@scrum-master' },
    { name: 'Engineering Manager', role: 'Development Lead', email: 'eng-manager@company.com', slack: '@eng-manager' },
    { name: 'UX Lead', role: 'User Experience', email: 'ux-lead@company.com', slack: '@ux-lead' }
  ],
  mentors: [
    { name: 'Senior Product Owner Mentor', expertise: 'Agile Product Ownership & Backlog Management', availability: 'Mon-Fri 2-4 PM' },
    { name: 'Stakeholder Management Mentor', expertise: 'Stakeholder Communication & Alignment', availability: 'Tue/Thu 10 AM-12 PM' },
    { name: 'Agile Practices Mentor', expertise: 'Scrum, Kanban & Agile Methodologies', availability: 'Wed/Fri 3-5 PM' }
  ],
  collaborators: [
    { team: 'Development Teams', contact: 'dev-teams@company.com', purpose: 'Sprint Planning & Backlog Refinement' },
    { team: 'UX/UI Team', contact: 'design-team@company.com', purpose: 'User Story Definition & Acceptance Criteria' },
    { team: 'QA Team', contact: 'qa-team@company.com', purpose: 'Acceptance Testing & Quality Assurance' },
    { team: 'Business Stakeholders', contact: 'stakeholders@company.com', purpose: 'Requirements Gathering & Prioritization' }
  ],
  channels: {
    primary: '#product-owners',
    announcements: '#product-announcements',
    help: '#product-owner-help',
    backlog: '#backlog-management',
    sprint: '#sprint-planning',
    stakeholders: '#stakeholder-updates',
    agile: '#agile-practices'
  }
};
